var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillScan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 82,
    viewBox: "0 0 79 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1047",
    d: "M76.5 9L76.5 6.33333C76.5 3.38781 74.1122 1 71.1667 1V1L68.5 1",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1054",
    d: "M10.5 1L8.5 1C5.18629 1 2.5 3.68629 2.5 7V7L2.5 10",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1053",
    d: "M2.5 61L2.5 63.6667C2.5 66.6122 4.88782 69 7.83333 69V69L10.5 69",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1055",
    d: "M68.5 69H71.1667C74.1122 69 76.5 66.6122 76.5 63.6667V63.6667V61",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1791",
    d: "M60.5 43.2081L59.0292 60.7106L52.3564 56.1731C51.9594 55.9031 51.4265 55.9534 51.087 56.2929L46.2236 61.1563L40.1292 56.2228C39.7623 55.9257 39.2377 55.9257 38.8708 56.2228L32.7764 61.1563L27.913 56.2929C27.5735 55.9534 27.0406 55.9031 26.6436 56.1731L19.9708 60.7106L18.5 43.2081V29.5V9.5C18.5 8.94772 18.9477 8.5 19.5 8.5H59.5C60.0523 8.5 60.5 8.94772 60.5 9.5V29.5V43.2081Z",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.375 17.125H42.25",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.375 24H42.25",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.375 37.75L24.375 47.375",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M40.875 37.75L40.875 47.375",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M49.125 37.75L49.125 47.375",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M54.625 37.75L54.625 47.375",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M50.5 17.125H54.625",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M50.5 24H54.625",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1792",
    d: "M28.5 37.9031C28.5 37.4091 28.8153 36.9702 29.2835 36.8126C31.4514 36.0827 33.7986 36.0827 35.9665 36.8126C36.4347 36.9702 36.75 37.4091 36.75 37.9031V47.2832C36.75 47.7406 36.4581 48.1469 36.0246 48.2929C33.819 49.0355 31.431 49.0355 29.2254 48.2929C28.7919 48.1469 28.5 47.7406 28.5 47.2832V37.9031Z",
    fill: "#0E5CF4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1793",
    x: 1.5,
    y: 82,
    width: 51,
    height: 76,
    transform: "rotate(-90 1.5 82)",
    fill: "url(#paint0_linear_103_28981)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1051",
    x: 0.5,
    y: 32,
    width: 2,
    height: 78,
    rx: 0.999999,
    transform: "rotate(-90 0.5 32)",
    fill: "#0E5CF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_28981",
    x1: 53.2727,
    y1: 121.982,
    x2: 1.05428,
    y2: 120.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5CF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E5CF4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillScan);
export default __webpack_public_path__ + "static/media/bill-scan.e836f19fd3f34d9c7cd3917f8ac82a23.svg";
export { ForwardRef as ReactComponent };